import { RequestService } from '../../../../common/services/RequestService';
import { GET_ALL_FILTERS } from '../constants';
import { dataAdjustmentResponse } from './dataAdjustment';

export const getAllFiltersRequest = async () => {
  const response = await RequestService.get(GET_ALL_FILTERS);
  return response && dataAdjustmentResponse(response.data);
};
